exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nowrap {\n  white-space: nowrap;\n  overflow: hidden; }\n\n:host /deep/ .content-area {\n  padding: 10px 24px 24px 24px !important; }\n\n.matTab {\n  width: 10% !important;\n  max-width: 110px !important;\n  margin-left: 5px !important; }\n\n.matLink {\n  width: 100% !important;\n  line-height: 24px !important;\n  border-style: solid !important;\n  border-width: 0px 1px 0px 0px !important; }\n\n.navMat {\n  padding-left: 5px !important;\n  height: 48px !important; }\n\n.perSecTab {\n  float: right; }\n\n.main-container .subnav {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 48px;\n          flex: 0 0 48px; }\n\n.red {\n  color: #F52F22 !important; }\n\n.small {\n  font-size: 13px; }\n\n.actMinH {\n  min-height: 400px; }\n\n:host /deep/ clr-tree-node {\n  overflow-y: visible !important; }\n\n.multiBuy {\n  border: none;\n  background: none;\n  color: #fafafa;\n  padding: 0;\n  vertical-align: middle;\n  max-width: 2.5rem; }\n\n#multiLabel:before {\n  display: none; }\n\n.branding {\n  min-width: auto !important; }\n\n:host /deep/ .nav-content {\n  padding-bottom: 25px; }\n\n:host /deep/ .darkFix {\n  background: #1b2a32; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 1